import React from 'react';
import ButtonAction from '../../../_common/components/ButtonAction';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {can} from '../../../_common/components/Permissions';
import {saveAs} from 'file-saver';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import PopupDeleteOrder from '../PopupDeleteOrder/PopupDeleteOrder';
import PopupFreezeOrder from '../PopupFrozeOrder/PopupFreezeOrder';
import {downloadOrderFiles} from '../../_redux/actions/OrdersPageTableActions';
import ButtonDD from "../../../_common/components/ButtonDD";

export function OrdersActionsColumnFormatter(cellContent, {history}) {
  const {orderNumber} = cellContent;
  const handleEditOrder = () => history.push(`/order-details/${orderNumber}`);
  const handleDownloadOrderFiles = async () => {
    try {
      const result = await downloadOrderFiles(orderNumber);
      if (result) {
        saveAs(result, `Order_${orderNumber}_files`);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{
          itemContent: (
            <div className="d-flex justify-content-between align-items-center">
              <ButtonAction
                variant={'icon'}
                iconButtonType={'primary'}
                title={TTS.EDIT}
                disabled={!can(T.FULL, S.ORDERS_PAGE)}
                onClick={handleEditOrder}
                label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="edit"/>}
                customClassnames={'mx-2'}
              />
              <PopupDeleteOrder data={cellContent}/>
              <PopupFreezeOrder data={cellContent}/>
              <ButtonAction
                variant={'icon'}
                iconButtonType={'secondary'}
                title={TTS.DOWNLOAD_FILE}
                disabled={!can(T.FULL, S.ORDERS_PAGE)}
                onClick={handleDownloadOrderFiles}
                label={<img src={toAbsoluteUrl('media/common/Download_secondary.svg')} alt="download"/>}
                customClassnames={'mx-2'}
              />
            </div>
          )
        }
        ]}
      />
    </div>
  );
}
